import Vue from 'vue';
import * as echarts from 'echarts';
import App from './App.vue';
import ElementUI from 'element-ui';
import '@tencent/tea-component/dist/themes/default-light.css';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index.js';
import store from './store/index';
import 'regenerator-runtime/runtime';
// import VueI18n from 'vue-i18n';
// import zh from './common/locales/zh.json';
// import en from './common/locales/en.json';
import elementUIen from 'element-ui/lib/locale/lang/en';
import elementUIzh from 'element-ui/lib/locale/lang/zh-CN';
import Cookies from 'js-cookie';
import i18n from "@/common/locales";

// 腾讯云弹层
window.QCCDN_HOST = 'cloudcache.tencent-cloud.com';
window.QCMAIN_HOST = 'cloud.tencent.com';

document.title = window.location.host.includes('eda') ? 'EDA上云' : '多物理场CAE仿真';

Vue.config.productionTip = false;

if (document.body.scrollWidth < 1600) {
  Vue.use(ElementUI, {
    size: 'mini',
    zIndex: 3000,
    locale: getElementUILocale(),
  });
}
if (document.body.scrollWidth > 1600 && document.body.scrollWidth < 2000) {
  Vue.use(ElementUI, {
    size: 'small',
    zIndex: 3000,
    locale: getElementUILocale(),
  });
}
if (document.body.scrollWidth > 2000) {
  Vue.use(ElementUI, {
    size: 'medium',
    zIndex: 3000,
    locale: getElementUILocale(),
  });
}
Vue.prototype.$echarts = echarts;
Vue.prototype.$eventBus = new Vue();

// // 1. 注册 vue-i18n 插件
// Vue.use(VueI18n);
//
// // 通过选项创建 VueI18n 实例
// const i18n = new VueI18n({
//   locale: Cookies.get('userLanguage') || 'zh', // 优先使用用户选择的语言，默认中文
//   fallbackLocale: 'en', // 回退语言
//   messages,
// });

function getElementUILocale() {
  return Cookies.get('userLanguage') === 'en' ? elementUIen : elementUIzh;
}

// 将 i18n 实例 挂载到windows上 全局使用
// 防止在js文件内无法导入i18n使用
window.$i18n = i18n;

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
}).$mount('#app');
